import React, { useState, useEffect } from "react";
import {
  Grid2,
  Typography,
  Box,
  Divider,
  TextField,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Select,
  FormControl,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, parse, isValid } from "date-fns";
import { Close, FormatBold, FormatItalic, FormatUnderlined } from "@mui/icons-material";

const SUPPORTED_FONTS = [
  { value: "Helvetica", label: "Helvetica" },
  { value: "Times-Roman", label: "Times Roman" },
  { value: "Courier", label: "Courier" },
];

const DATE_FORMAT_OPTIONS = [
  { value: "MM/dd/yyyy", label: "Month / Day / Year" },
  { value: "dd/MM/yyyy", label: "Day / Month / Year" },
  { value: "MMM dd, yyyy", label: "Month Day, Year" },
];

const DatePickerComponent = ({
  selectedAnnotation,
  onUpdateAnnotation,
  type,
  closeButton,
}) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [fontSize, setFontSize] = useState(21); // Default font size same as text annotations
  const [fontFamily, setFontFamily] = useState("Helvetica");
  const [textFormat, setTextFormat] = useState([]);
  const [dateFormat, setDateFormat] = useState("MMM dd, yyyy");
  const [isRequired, setIsRequired] = useState(false);
  // const FONT_SIZE_OPTIONS = [
  //   { label: "7", value: 14 },
  //   { label: "9", value: 16 },
  //   { label: "11", value: 18 },
  //   { label: "12", value: 20 },
  //   { label: "14", value: 22 },
  //   { label: "16", value: 24 },
  //   { label: "18", value: 26 },
  //   { label: "20", value: 28 },
  // ];
  const FONT_SIZE_OPTIONS = [
    { label: "7", value: 17 },

    { label: "9", value: 19 },
    { label: "11", value: 21 },
    { label: "12", value: 23 },
    { label: "14", value: 25 },
    { label: "16", value: 27 },
    { label: "18", value: 29 },
    { label: "20", value: 31 },
  ];
  // Parse date string to Date object
  const parseDateString = (dateString, format) => {
    try {
      if (!dateString) return new Date();
      // If dateString is already a Date object
      if (dateString instanceof Date) return dateString;
      // Try parsing with the current format
      const parsedDate = parse(dateString, format, new Date());
      return isValid(parsedDate) ? parsedDate : new Date();
    } catch (error) {
      console.error("Error parsing date:", error);
      return new Date();
    }
  };

  // useEffect(() => {
  //   if (selectedAnnotation) {
  //     try {
  //       const initialDate = parseDateString(
  //         selectedAnnotation.text,
  //         selectedAnnotation.dateFormat || dateFormat
  //       );
  //       setSelectedDate(initialDate);
  //       setFontSize(selectedAnnotation.fontSize || 14);
  //       setDateFormat(selectedAnnotation.dateFormat || "MM/dd/yyyy");
  //     } catch (error) {
  //       console.error("Error setting initial date:", error);
  //       setSelectedDate(new Date());
  //     }
  //   }
  // }, [selectedAnnotation]);

  const handleDateChange = (date) => {
    if (!date || !isValid(date)) return;
    if (type === "signer_date") return; // signer_date never stores a date

    setSelectedDate(date);
    try {
      const formattedDate = format(date, dateFormat);
      updateAnnotation(formattedDate, dateFormat, fontSize, isRequired, fontFamily, textFormat);
    } catch (error) {
      console.error("Error formatting date:", error);
    }
  };

  const safeFormattedDate = () =>
    type === "signer_date" || !selectedDate ? "" : format(selectedDate, dateFormat);

  const handleFormatChange = (e) => {
    const newFormat = e.target.value;
    setDateFormat(newFormat);
    try {
      // Only send format + text so position/size recalculation does not shift the field down
      const formattedDate =
        type === "signer_date" || !selectedDate
          ? ""
          : format(selectedDate, newFormat);
      onUpdateAnnotation({
        dateFormat: newFormat,
        text: formattedDate,
      });
    } catch (error) {
      console.error("Error updating format:", error);
    }
  };

  const handleFontSizeChange = (newSize) => {
    setFontSize(newSize);
    updateAnnotation(safeFormattedDate(), dateFormat, newSize, isRequired, fontFamily, textFormat);
  };

  const handleFontFamilyChange = (newFontFamily) => {
    setFontFamily(newFontFamily);
    updateAnnotation(safeFormattedDate(), dateFormat, fontSize, isRequired, newFontFamily, textFormat);
  };

  const handleTextFormatChange = (event, newFormats) => {
    setTextFormat(newFormats);
    updateAnnotation(safeFormattedDate(), dateFormat, fontSize, isRequired, fontFamily, newFormats);
  };
  useEffect(() => {
    if (selectedAnnotation) {
      try {
        // signer_date (FOR OTHERS): never show or store a date value — keep empty for backend
        if (type === "signer_date") {
          setSelectedDate(null);
        } else {
          const initialDate = parseDateString(
            selectedAnnotation.text,
            selectedAnnotation.dateFormat || dateFormat
          );
          setSelectedDate(initialDate);
        }
        setFontSize(selectedAnnotation.fontSize || 21); // Default font size same as text annotations
        setFontFamily(selectedAnnotation.fontFamily || "Helvetica");
        setTextFormat(selectedAnnotation.format || []);
        setDateFormat(selectedAnnotation.dateFormat || "MM/dd/yyyy");
        setIsRequired(selectedAnnotation.isRequired || false);
      } catch (error) {
        console.error("Error setting initial date:", error);
      }
    }
  }, [selectedAnnotation, type]);

  // Add handler for required switch

  // useEffect(() => {
  //   if (selectedAnnotation) {
  //     try {
  //       // If there's existing text, parse it with the existing format
  //       if (selectedAnnotation.text) {
  //         const existingFormat = selectedAnnotation.dateFormat || dateFormat;
  //         const parsedDate = parse(
  //           selectedAnnotation.text,
  //           existingFormat,
  //           new Date()
  //         );
  //         setSelectedDate(isValid(parsedDate) ? parsedDate : new Date());
  //       } else {
  //         setSelectedDate(new Date());
  //       }

  //       // Set other properties
  //       setFontSize(selectedAnnotation.fontSize || 14);
  //       setDateFormat(selectedAnnotation.dateFormat || "MM/dd/yyyy");
  //       setIsRequired(selectedAnnotation.isRequired || false);

  //       // Update annotation with initial format if no text exists
  //       if (!selectedAnnotation.text) {
  //         updateAnnotation(
  //           format(new Date(), selectedAnnotation.dateFormat || "MM/dd/yyyy"),
  //           selectedAnnotation.dateFormat || "MM/dd/yyyy",
  //           selectedAnnotation.fontSize || 14,
  //           selectedAnnotation.isRequired || false
  //         );
  //       }
  //     } catch (error) {
  //       console.error("Error setting initial date:", error);
  //     }
  //   }
  // }, [selectedAnnotation]);
  const handleRequiredChange = (event) => {
    const newRequired = event.target.checked;
    setIsRequired(newRequired);
    // For signer_date: only update isRequired to prevent width recalculation
    if (type === "signer_date") {
      onUpdateAnnotation({
        isRequired: newRequired,
      });
    } else {
      updateAnnotation(
        safeFormattedDate(),
        dateFormat,
        fontSize,
        newRequired,
        fontFamily,
        textFormat
      );
    }
  };

  const updateAnnotation = (
    formattedDate,
    newFormat = dateFormat,
    newSize = fontSize,
    required = isRequired,
    newFontFamily = fontFamily,
    newTextFormat = textFormat
  ) => {
    // signer_date (FOR OTHERS): never send a date value — keep text empty for backend
    if (type === "signer_date") {
      onUpdateAnnotation({
        ...selectedAnnotation,
        text: "",
        dateFormat: newFormat,
        fontSize: newSize,
        fontFamily: newFontFamily,
        format: newTextFormat,
        type: selectedAnnotation.type,
        isRequired: required,
        x: selectedAnnotation.x,
        y: selectedAnnotation.y,
      });
      return;
    }

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    // Get current annotation properties
    const currentDate = selectedAnnotation.text
      ? parse(
        selectedAnnotation.text,
        selectedAnnotation.dateFormat || "MM/dd/yyyy",
        new Date()
      )
      : selectedDate;

    // Format date with new format if changing format
    const finalDate =
      newFormat !== selectedAnnotation.dateFormat
        ? format(currentDate, newFormat)
        : formattedDate;

    // Build font string with format
    const fontWeight = newTextFormat.includes("bold") ? "bold" : "normal";
    const fontStyle = newTextFormat.includes("italic") ? "italic" : "normal";
    ctx.font = `${fontStyle} ${fontWeight} ${newSize}px ${newFontFamily}`;

    const metrics = ctx.measureText(formattedDate);
    const textWidth = Math.ceil(metrics.width);
    const minWidth = Math.max(150, newSize * 8);

    const padding = 16;
    const buffer = 2;
    const finalWidth = Math.max(minWidth, textWidth + padding + buffer);

    onUpdateAnnotation({
      ...selectedAnnotation,
      text: formattedDate,
      dateFormat: newFormat,
      fontSize: newSize,
      fontFamily: newFontFamily,
      format: newTextFormat,
      width: finalWidth,
      type: selectedAnnotation.type,
      isRequired: required,
      x: selectedAnnotation.x,
      y: selectedAnnotation.y,
    });
  };

  return (
    <>
      <Box
        sx={{
          p: 2,
          width: "100%",
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          boxSizing: "border-box",
        }}
      >
        {/* <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            fontSize: "16px",
            color: "rgba(0, 0, 0, 0.87)",
            mb: 2.5,
            width: "100%",
          }}
        >
          Date
        </Typography> */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2.5,
            mt: 1,
            // px: 1,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              color: "rgba(0, 0, 0, 0.87)",
              // mb: 2.5,
              width: "100%",
            }}
          >
            Date
          </Typography>

          <Close
            style={{
              cursor: "pointer",
              color: "rgba(0, 0, 0, 0.54)",
              "&:hover": {
                color: "rgba(0, 0, 0, 0.87)",
              },
              fontSize: "20px",
            }}
            onClick={closeButton}
          />
        </Box>
        <Grid2 container spacing={2.5} direction="column">
          {/* Add Required Switch for signer date only */}
          {type === "signer_date" && (
            <Grid2 item xs={12}>
              {/* <FormControlLabel
                control={
                  <Switch
                    checked={isRequired}
                    onChange={handleRequiredChange}
                    color="primary"
                  />
                }
                label={
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 600,
                      color: "#666",
                    }}
                  >
                    Required
                  </Typography>
                }
              /> */}
              <FormControlLabel
                sx={{
                  margin: 0,
                  "& .MuiFormControlLabel-label": {
                    margin: 0,
                  },
                }}
                control={
                  <Checkbox
                    checked={isRequired}
                    onChange={handleRequiredChange}
                    size="small"
                    sx={{
                      color: "rgba(0, 0, 0, 0.54)",
                      "&.Mui-checked": {
                        color: "rgb(0, 145, 255)",
                      },
                      padding: "4px",
                    }}
                  />
                }
                label={
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "13px",
                      color: "rgba(0, 0, 0, 0.7)",
                      ml: 0.5,
                    }}
                  >
                    Required
                  </Typography>
                }
              />
            </Grid2>
          )}
          {/* Hide Select Date for signer_date (FOR OTHERS) — no date value is stored or sent */}
          {type !== "signer_date" && (
            <Grid2 item xs={12}>
              <Typography
                variant="body2"
                sx={{
                  fontSize: "13px",
                  color: "rgba(0, 0, 0, 0.7)",
                  mb: 1,
                }}
              >
                Select Date
              </Typography>
              <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                dateFormat={dateFormat}
                calendarClassName="small-calendar"
                popperClassName="small-calendar-popper"
                customInput={
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    sx={{
                      // mb: 2.5,
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#fff",
                        "& fieldset": {
                          borderColor: "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: "rgba(0, 145, 255, 0.5)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "rgb(0, 145, 255)",
                        },
                      },
                    }}
                  />
                }
              />
            </Grid2>
          )}

          <Grid2 item xs={12}>
            <Typography
              variant="body2"
              sx={{
                fontSize: "13px",
                color: "rgba(0, 0, 0, 0.7)",
                mb: 1,
              }}
            >
              Font Size
            </Typography>
            <TextField
              select
              fullWidth
              size="small"
              value={fontSize}
              onChange={(e) => handleFontSizeChange(Number(e.target.value))}
              sx={{
                "& .MuiSelect-select": {
                  py: 1,
                  fontSize: "14px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(0, 0, 0, 0.23)",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(0, 145, 255, 0.5)",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgb(0, 145, 255)",
                },
              }}
            >
              {/* {[10, 11, 12, 14, 16, 18, 20, 22, 24].map((size) => (
                <MenuItem
                  key={size}
                  value={size}
                  sx={{
                    fontSize: "14px",
                    py: 1,
                    "&:hover": {
                      backgroundColor: "rgba(0, 145, 255, 0.08)",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "rgba(0, 145, 255, 0.16)",
                      "&:hover": {
                        backgroundColor: "rgba(0, 145, 255, 0.24)",
                      },
                    },
                  }}
                >
                  {size}px
                </MenuItem>
              ))} */}
              {FONT_SIZE_OPTIONS.map((size) => (
                <MenuItem
                  key={size.value}
                  value={size.value} // Actual font size in pixels (like 14px)
                  sx={{
                    fontSize: "14px",
                    py: 1,
                    "&:hover": {
                      backgroundColor: "rgba(0, 145, 255, 0.08)",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "rgba(0, 145, 255, 0.16)",
                      "&:hover": {
                        backgroundColor: "rgba(0, 145, 255, 0.24)",
                      },
                    },
                  }}
                >
                  {size.label}{" "}
                  {/* Display only the font size number like '9' */}
                </MenuItem>
              ))}
            </TextField>
          </Grid2>

          {/* Font Family */}
          <Grid2 item xs={12}>
            <Typography
              variant="body2"
              sx={{
                fontSize: "13px",
                color: "rgba(0, 0, 0, 0.7)",
                mb: 1,
              }}
            >
              Font Family
            </Typography>
            <FormControl fullWidth size="small">
              <Select
                value={fontFamily}
                onChange={(e) => handleFontFamilyChange(e.target.value)}
                sx={{
                  "& .MuiSelect-select": {
                    py: 1,
                    fontSize: "14px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(0, 0, 0, 0.23)",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(0, 145, 255, 0.5)",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgb(0, 145, 255)",
                  },
                }}
              >
                {SUPPORTED_FONTS.map((font) => (
                  <MenuItem
                    key={font.value}
                    value={font.value}
                    sx={{
                      fontSize: "14px",
                      fontFamily: font.value,
                      "&:hover": {
                        backgroundColor: "rgba(0, 145, 255, 0.08)",
                      },
                      "&.Mui-selected": {
                        backgroundColor: "rgba(0, 145, 255, 0.16)",
                        "&:hover": {
                          backgroundColor: "rgba(0, 145, 255, 0.24)",
                        },
                      },
                    }}
                  >
                    {font.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>

          {/* Text Style */}
          <Grid2 item xs={12}>
            <Typography
              variant="body2"
              sx={{
                fontSize: "13px",
                color: "rgba(0, 0, 0, 0.7)",
                mb: 1,
              }}
            >
              Text Style
            </Typography>
            <ToggleButtonGroup
              value={textFormat}
              onChange={handleTextFormatChange}
              size="small"
              fullWidth
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: "stretch",
                "& .MuiToggleButton-root": {
                  py: 1,
                  border: "1px solid rgba(0, 0, 0, 0.12)",
                  "&.Mui-selected": {
                    backgroundColor: "rgba(0, 145, 255, 0.08)",
                    color: "rgb(0, 145, 255)",
                    "&:hover": {
                      backgroundColor: "rgba(0, 145, 255, 0.12)",
                    },
                  },
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                  },
                },
                "& .MuiSvgIcon-root": {
                  fontSize: "20px",
                },
              }}
            >
              <ToggleButton value="bold">
                <FormatBold />
              </ToggleButton>
              <ToggleButton value="italic">
                <FormatItalic />
              </ToggleButton>
              <ToggleButton value="underline">
                <FormatUnderlined />
              </ToggleButton>
            </ToggleButtonGroup>
          </Grid2>

          <Grid2 item xs={12}>
            <Typography
              variant="body2"
              sx={{
                fontSize: "13px",
                color: "rgba(0, 0, 0, 0.7)",
                mb: 1,
              }}
            >
              Date Format
            </Typography>
            <FormControl fullWidth size="small">
              <Select
                value={dateFormat}
                onChange={handleFormatChange}
                renderValue={(value) =>
                  DATE_FORMAT_OPTIONS.find((opt) => opt.value === value)?.label ?? value
                }
                sx={{
                  "& .MuiSelect-select": {
                    py: 1,
                    fontSize: "14px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(0, 0, 0, 0.23)",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(0, 145, 255, 0.5)",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgb(0, 145, 255)",
                  },
                }}
              >
                {DATE_FORMAT_OPTIONS.map((opt) => (
                  <MenuItem
                    key={opt.value}
                    value={opt.value}
                    sx={{
                      fontSize: "14px",
                      py: 1,
                      "&:hover": {
                        backgroundColor: "rgba(0, 145, 255, 0.08)",
                      },
                      "&.Mui-selected": {
                        backgroundColor: "rgba(0, 145, 255, 0.16)",
                        "&:hover": {
                          backgroundColor: "rgba(0, 145, 255, 0.24)",
                        },
                      },
                    }}
                  >
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
        </Grid2>
      </Box>
    </>
  );
};

export default DatePickerComponent;
